import { Box } from '@rbilabs/universal-components';

export const BodyContainer = Box.withConfig({
  maxWidth: 320,
});

export const ItemContainer = Box.withConfig({
  marginTop: '$4',
});

export const SubtitleContainer = Box.withConfig({
  _text: {
    fontWeight: 'bold',
  },

  flexDirection: 'row',
});
